/**
 * Normalizes a folder name for display. If the folder is the project root
 * (named "root"), substitutes the project name instead.
 */
export const normalizeRootFolderName = (
  folderName: string | null | undefined,
  projectName: string | null | undefined
): string | null => {
  if (folderName === 'root') {
    return projectName ?? 'Root';
  }
  return folderName ?? null;
};
